<div *ngIf="showCampaignBanner && slides().length > 0">
  <swiper-container
    pagination="true"
    autoplay-delay="5000"
    autoplay-disable-on-interaction="false"
    loop="true"
    class="banner-swiper"
  >
    <swiper-slide *ngFor="let slide of slides()">
      <div
        class="banner-slide"
        (click)="onSlideClick(slide)"
        [style.cursor]="slide.href ? 'pointer' : 'default'"
      >
        <img [src]="slide.src" [alt]="slide.alt" class="banner-image" />
      </div>
    </swiper-slide>
  </swiper-container>
</div>
